export default __webpack_public_path__ + "static/media/0x11a819beb0aa3327e39f52f90d65cc9bca499f33.c3eb6ad4.webp";